import parse from "html-react-parser";

type BaseQuoteType = {
  text: string;
  customColor?: string;
  classProps?: string;
  textPosition?: string;
  italic?: boolean;
  textSize?: string;
  textBig?: boolean;
  textAnimationBlock?: boolean;
};

export const baseQuoteParseOptions = {
  replace: (domNode: any) => {
    if (domNode.name === "strong") {
      return <span className="text-primary">{domNode.children[0].data}</span>;
    }
    return undefined;
  },
};

export default function BaseQuote(props: BaseQuoteType) {
  return (
    <p
      className={`${
        props.textSize ? props.textSize : props.textBig ? "text-xl sm:text-3xl" : "text-xl"
      } font-text tracking-wide uppercase font-semibold ${
        props.textPosition ?? `text-center`
      } ${props.italic && "italic"} grow text-white ${props.customColor} ${
        props.classProps
      }`}
    >
      {parse(props.text, baseQuoteParseOptions)}
    </p>
  );
}
